import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry:false,
      // refetchInterval:
      // false,
      // DEFAULT_RETRY_INTERVAL,
    },
  },
});
